/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MeterValuesSnapshot
 */
export interface MeterValuesSnapshot {
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    frequencyHz?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l1VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l2VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l3VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l1CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l2CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l3CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l1ActivePowerRmsKw?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l2ActivePowerRmsKw?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l3ActivePowerRmsKw?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l1ReactivePowerRmsKVar?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l2ReactivePowerRmsKVar?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    l3ReactivePowerRmsKVar?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    activeEnergyImportKWh?: number;
    /**
     *
     * @type {number}
     * @memberof MeterValuesSnapshot
     */
    activeEnergyExportKWh?: number;
}

/**
 * Check if a given object implements the MeterValuesSnapshot interface.
 */
export function instanceOfMeterValuesSnapshot(
    value: object,
): value is MeterValuesSnapshot {
    return true;
}

export function MeterValuesSnapshotFromJSON(json: any): MeterValuesSnapshot {
    return MeterValuesSnapshotFromJSONTyped(json, false);
}

export function MeterValuesSnapshotFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): MeterValuesSnapshot {
    if (json == null) {
        return json;
    }
    return {
        frequencyHz:
            json["frequencyHz"] == null ? undefined : json["frequencyHz"],
        l1VoltageRmsV:
            json["l1VoltageRmsV"] == null ? undefined : json["l1VoltageRmsV"],
        l2VoltageRmsV:
            json["l2VoltageRmsV"] == null ? undefined : json["l2VoltageRmsV"],
        l3VoltageRmsV:
            json["l3VoltageRmsV"] == null ? undefined : json["l3VoltageRmsV"],
        l1CurrentRmsA:
            json["l1CurrentRmsA"] == null ? undefined : json["l1CurrentRmsA"],
        l2CurrentRmsA:
            json["l2CurrentRmsA"] == null ? undefined : json["l2CurrentRmsA"],
        l3CurrentRmsA:
            json["l3CurrentRmsA"] == null ? undefined : json["l3CurrentRmsA"],
        l1ActivePowerRmsKw:
            json["l1ActivePowerRmsKw"] == null
                ? undefined
                : json["l1ActivePowerRmsKw"],
        l2ActivePowerRmsKw:
            json["l2ActivePowerRmsKw"] == null
                ? undefined
                : json["l2ActivePowerRmsKw"],
        l3ActivePowerRmsKw:
            json["l3ActivePowerRmsKw"] == null
                ? undefined
                : json["l3ActivePowerRmsKw"],
        l1ReactivePowerRmsKVar:
            json["l1ReactivePowerRmsKVar"] == null
                ? undefined
                : json["l1ReactivePowerRmsKVar"],
        l2ReactivePowerRmsKVar:
            json["l2ReactivePowerRmsKVar"] == null
                ? undefined
                : json["l2ReactivePowerRmsKVar"],
        l3ReactivePowerRmsKVar:
            json["l3ReactivePowerRmsKVar"] == null
                ? undefined
                : json["l3ReactivePowerRmsKVar"],
        activeEnergyImportKWh:
            json["activeEnergyImportKWh"] == null
                ? undefined
                : json["activeEnergyImportKWh"],
        activeEnergyExportKWh:
            json["activeEnergyExportKWh"] == null
                ? undefined
                : json["activeEnergyExportKWh"],
    };
}

export function MeterValuesSnapshotToJSON(
    value?: MeterValuesSnapshot | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        frequencyHz: value["frequencyHz"],
        l1VoltageRmsV: value["l1VoltageRmsV"],
        l2VoltageRmsV: value["l2VoltageRmsV"],
        l3VoltageRmsV: value["l3VoltageRmsV"],
        l1CurrentRmsA: value["l1CurrentRmsA"],
        l2CurrentRmsA: value["l2CurrentRmsA"],
        l3CurrentRmsA: value["l3CurrentRmsA"],
        l1ActivePowerRmsKw: value["l1ActivePowerRmsKw"],
        l2ActivePowerRmsKw: value["l2ActivePowerRmsKw"],
        l3ActivePowerRmsKw: value["l3ActivePowerRmsKw"],
        l1ReactivePowerRmsKVar: value["l1ReactivePowerRmsKVar"],
        l2ReactivePowerRmsKVar: value["l2ReactivePowerRmsKVar"],
        l3ReactivePowerRmsKVar: value["l3ReactivePowerRmsKVar"],
        activeEnergyImportKWh: value["activeEnergyImportKWh"],
        activeEnergyExportKWh: value["activeEnergyExportKWh"],
    };
}
